module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114124_87_157.b6bba9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114124_87_157.jpg
// module id = sCRI
// module chunks = 0